// extracted by mini-css-extract-plugin
export default {"counter":"styles_counter__jEcTo"};